import React, { lazy } from 'react';

// Supplier Digital Reporting
const SupplierReportingSubmenu = lazy(() =>
  import('./SupplierReportingSubmenu').then(module => ({
    default: module.SupplierReportingSubmenu,
  })),
);

const SupplierAdvanceLedgerReport = lazy(() =>
  import('./PreviewPage/SupplierAdvanceLedgerReport').then(module => ({
    default: module.SupplierAdvanceLedgerReport,
  })),
);

const SupplierLedgerReport = lazy(() =>
  import('./PreviewPage/SupplierLedgerReport').then(module => ({
    default: module.SupplierLedgerReport,
  })),
);

const SupplierLedgerReportByDocDate = lazy(() =>
  import('./PreviewPage/SupplierLedgerReportbyDocDate').then(module => ({
    default: module.SupplierLedgerReportByDocDate,
  })),
);

const SupplierAgingDetailbyProject = lazy(() =>
  import('./PreviewPage/SupplierAgingDetailbyProject').then(module => ({
    default: module.SupplierAgingDetailbyProject,
  })),
);

const SupplierAgingDetailReportbyTrxDate = lazy(() =>
  import('./PreviewPage/SupplierAgingDetailReportbyTrxDate').then(module => ({
    default: module.SupplierAgingDetailReportbyTrxDate,
  })),
);

const SupplierAgingDetailReportbyDocDate = lazy(() =>
  import('./PreviewPage/SupplierAgingDetailReportbyDocDate').then(module => ({
    default: module.SupplierAgingDetailReportbyDocDate,
  })),
);

const SupplierAgingSummaryReportbyTrxDate = lazy(() =>
  import('./PreviewPage/SupplierAgingSummaryReportbyTrxDate').then(module => ({
    default: module.SupplierAgingSummaryReportbyTrxDate,
  })),
);

const SupplierAgingSummaryReportbyProject = lazy(() =>
  import('./PreviewPage/SupplierAgingSummaryReportbyProject').then(module => ({
    default: module.SupplierAgingSummaryReportbyProject,
  })),
);

const SupplierControlSummaryReport = lazy(() =>
  import('./PreviewPage/SupplierControlSummaryReport').then(module => ({
    default: module.SupplierControlSummaryReport,
  })),
);

const SupplierLedgerReportbyProject = lazy(() =>
  import('./PreviewPage/SupplierLedgerReportbyProject').then(module => ({
    default: module.SupplierLedgerReportbyProject,
  })),
);

const SupplierDetailBreakdownReport = lazy(() =>
  import('./PreviewPage/SupplierDetailBreakdownReport').then(module => ({
    default: module.SupplierDetailBreakdownReport,
  })),
);

const supplierReportingRoutes = [
  {
    props: {
      exact: true,
      path: '/supplier/digital-reporting',
      // path: '/supplier/digital-reporting/:supplierID',
    },
    component: <SupplierReportingSubmenu />,
  },
  {
    props: {
      exact: true,
      path: '/supplier/digital-reporting/parameter/advance-ledger-report/view',
      // path: '/supplier/digital-reporting/:supplierID/advance-ledger-report',
    },
    component: (
      <SupplierAdvanceLedgerReport reportMode="advance-ledger-report" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/supplier/digital-reporting/parameter/ledger-report/view',
      // path: '/supplier/digital-reporting/:supplierID/ledger-report',
    },
    component: <SupplierLedgerReport reportMode="ledger-report" />,
  },
  {
    props: {
      exact: true,
      path: '/supplier/digital-reporting/parameter/ledger-report-docdate/view',
      // path: '/supplier/digital-reporting/:supplierID/ledger-report',
    },
    component: (
      <SupplierLedgerReportByDocDate reportMode="ledger-report-docdate" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/supplier/digital-reporting/parameter/control-summary/view',
      // path: '/supplier/digital-reporting/:supplierID/control-summary',
    },
    component: <SupplierControlSummaryReport reportMode="control-summary" />,
  },
  {
    props: {
      exact: true,
      path: '/supplier/digital-reporting/parameter/aging-detail-date/view',
      // path: '/supplier/digital-reporting/:supplierID/aging-detail-date',
    },
    component: (
      <SupplierAgingDetailReportbyTrxDate reportMode="aging-detail-date" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/supplier/digital-reporting/parameter/aging-detail-docdate/view',
      // path: '/supplier/digital-reporting/:supplierID/aging-detail-date',
    },
    component: (
      <SupplierAgingDetailReportbyDocDate reportMode="aging-detail-docdate" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/supplier/digital-reporting/parameter/aging-detail-project/view',
      // path: '/supplier/digital-reporting/:supplierID/aging-detail-project',
    },
    component: (
      <SupplierAgingDetailbyProject reportMode="aging-detail-project" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/supplier/digital-reporting/parameter/aging-summary-date/view',
      // path: '/supplier/digital-reporting/:supplierID/aging-summary-date',
    },
    component: (
      <SupplierAgingSummaryReportbyTrxDate reportMode="aging-summary-date" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/supplier/digital-reporting/parameter/aging-summary-project/view',
    },
    component: (
      <SupplierAgingSummaryReportbyProject reportMode="aging-summary-project" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/supplier/digital-reporting/parameter/detail-breakdown/view',
      // path: '/supplier/digital-reporting/:supplierID/detail-breakdown',
    },
    component: <SupplierDetailBreakdownReport reportMode="detail-breakdown" />,
  },
  {
    props: {
      exact: true,
      path: '/supplier/digital-reporting/parameter/ledger-report-project/view',
      // path: '/supplier/digital-reporting/:supplierID/ledger-report-project',
    },
    component: (
      <SupplierLedgerReportbyProject reportMode="ledger-report-project" />
    ),
  },
];

export default supplierReportingRoutes;
